import { IJobEducation1, IJobEducation2, IJobFamily, IJobExpJob, IJobExpInfo, IJobEducation3License, IJobEducation3 } from './../constants/models';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { cmsApi } from '../constants/constants'
import { oneAssetApi } from '../constants/constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class JobService {
  isTesting = false
  constructor(private http: HttpClient) { }

  // List รายการตำแหน่งงาน
  getJobList(): Observable<any> {

    let URL = cmsApi + '/getjobList';
    let body = {};
    return this.http.post(URL, body);
  }

  // รายละเอียดงาน
  getJobDetail(bi): Observable<any> {
    let URL = cmsApi + '/getjobDetail';
    let body = { id: bi };

    return this.http.post(URL, body);
  }

  upload_blob_to_cloud(data,file_type): Observable<any> {
    let URL = 'http://localhost:8000/api/cloud/uploadblobtocloud/';
    let body = {
      data :data,
      file_type: file_type
    }
    return this.http.post(URL, body);
  }
  // add_job_register
  setApply_Personal(expected_salary,title_th, fname_th, lname_th, title_en, fname_en, lname_en, tel, mobile, email, birthday, age, identity, domicile, nationality, religion, contact_address, jobid, yearType,address,military_status): Observable<any> {
    let URL = cmsApi + '/add_job_register';
    let body = {
      expected_salary :expected_salary,
      title_th: title_th,
      fname_th: fname_th,
      lname_th: lname_th,
      title_en: title_en,
      fname_en: fname_en,
      lname_en: lname_en,
      tel: tel,
      mobile: mobile,
      email: email,
      birthday: birthday,
      age: age,
      identity: identity,
      domicile: domicile,
      nationality: nationality,
      religion: religion,
      contact_address: contact_address,
      jobid: jobid,
      yearType: yearType,
      address:address,
      military_status:military_status
    };

    if (this.isTesting) {
      console.log('body setApply_Personal', body);
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
        }, 100);
      });
    } else {
      console.log('body setApply_Personal', body);
      return this.http.post(URL, body);
    }



  }

  // UploadFile_education
  UploadFile_education(fileItem) {


    // const uploadUrl = cmsApi + '/datadetails';
    const uploadUrl = cmsApi + '/UploadFile_education';
    const uploadFormData = new FormData();
    uploadFormData.append('file', fileItem);
    const body = uploadFormData
    return this.http.post(uploadUrl, body);
  }


  // add_job_register_education1
  setEducation_1(personid, education, NameOfInstitute, major, graduate, FromMonthYear, ToMonthYear, gpa, seq, educationOther): Observable<any> {
    let URL = cmsApi + '/add_job_register_education1';


    let body = {
      personid: personid,
      education: education,
      NameOfInstitute: NameOfInstitute,
      major: major,
      graduate: graduate,
      FromMonthYear: FromMonthYear,
      ToMonthYear: ToMonthYear,
      gpa: gpa,
      seq: seq,
      educationOther: educationOther,
    }

    if (this.isTesting) {
      console.log('body setEducation_1', body);
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
        }, 100);
      });
    } else {
      return this.http.post(URL, body);
    }


  }
  setEducations_1(params:IJobEducation1[]): Observable<any> {
    let URL = cmsApi + '/add_job_register_educations1';
    if (this.isTesting) {
      console.log('body setEducations_1', params);
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
        }, 100);
      });
    } else {
      return this.http.post(URL, params);
    }


  }
  // add_job_register_education2
  setEducations_2(param:IJobEducation2): Observable<any> {
    let URL = cmsApi + '/add_job_register_educations2';    
    if (this.isTesting) {
      console.log('body setEducation_2', param);
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
        }, 100);
      });
    } else {
      return this.http.post(URL, param);
    }

  }
  setEducation_2(personid, file1, language, speaking, understanding, reading, writting, seq): Observable<any> {
    let URL = cmsApi + '/add_job_register_education2';
    let body = {
      personid: personid,
      file1: file1,
      language: language,
      speaking: speaking,
      understanding: understanding,
      reading: reading,
      writting: writting,
      seq: seq
    }
    if (this.isTesting) {
      console.log('body setEducation_2', body);
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
        }, 100);
      });
    } else {
      return this.http.post(URL, body);
    }

  }

  // add_job_register_education3
  setEducation_3(personid, licenseName, licenseNo, licenseDate, seq): Observable<any> {
    let URL = cmsApi + '/add_job_register_education3';
    let body = {
      personid: personid,
      licenseName: licenseName,
      licenseNo: licenseNo,
      licenseDate: licenseDate,
      seq: seq
    }
    if (this.isTesting) {
      console.log('body setEducation_3', body);
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
        }, 100);
      });
    } else {
      return this.http.post(URL, body);
    }
  }
  setEducations_3(params:IJobEducation3): Observable<any> {
    let URL = cmsApi + '/add_job_register_educations3';
    if (this.isTesting) {
      console.log('body setEducations_3', params);
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
        }, 100);
      });
    } else {
      return this.http.post(URL, params);
    }
  }
  // add_job_register_education4
  setEducation_4(body): Observable<any> {
    let URL = cmsApi + '/add_job_register_education4';
    if (this.isTesting) {
      console.log('body setEducation_4', body);
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
        }, 100);
      });
    } else {
      return this.http.post(URL, body);
    }
  }

  // add_job_register_family_age
  setAge(itemid, itemaage, seq): Observable<any> {
    let URL = cmsApi + '/add_job_register_family_age';
    let body = {
      personid: itemid,
      age: itemaage,
      seq: seq
    }
    if (this.isTesting) {
      console.log('body AGE', body);
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
        }, 100);
      });
    } else {
      return this.http.post(URL, body);
    }
  }

  // add_job_register_family
  setfamilies(param:IJobFamily): Observable<any> {
    let URL = cmsApi + '/add_job_register_families';
    if (this.isTesting) {
      console.log('Family', param)
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
        }, 100);
      });
    } else {
      return this.http.post(URL, param);
    }
  }
  setfamily(personid, MaritalStatus, NumberChildren, f_title, f_fname, f_lname, f_age, f_occupation, f_address, f_tel,
    m_title, m_fname, m_lname, m_age, m_occupation, m_address, m_tel, urgent_title, urgent_fname, urgent_lname,
    urgent_tel, urgent_address, urgent_relation, s_title, s_fname, s_lname, s_age, s_occupation, s_address, s_tel): Observable<any> {
    let URL = cmsApi + '/add_job_register_family';
    let body = {

      personid: personid,
      MaritalStatus: MaritalStatus,
      NumberChildren: NumberChildren,
      f_title: f_title,
      f_fname: f_fname,
      f_lname: f_lname,
      f_age: f_age,
      f_occupation: f_occupation,
      f_address: f_address,
      f_tel: f_tel,
      m_title: m_title,
      m_fname: m_fname,
      m_lname: m_lname,
      m_age: m_age,
      m_occupation: m_occupation,
      m_address: m_address,
      m_tel: m_tel,
      urgent_title: urgent_title,
      urgent_fname: urgent_fname,
      urgent_lname: urgent_lname,
      urgent_tel: urgent_tel,
      urgent_address: urgent_address,
      urgent_relation: urgent_relation,
      s_title: s_title,
      s_fname: s_fname,
      s_lname: s_lname,
      s_age: s_age,
      s_occupation: s_occupation,
      s_address: s_address,
      s_tel: s_tel,

    }
    if (this.isTesting) {
      console.log('Family', body)
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
        }, 100);
      });
    } else {
      return this.http.post(URL, body);
    }
  }

  // add_job_register_family_brother_sister
  setbrother(personid, b_title, b_fname, b_lname, b_age, b_occupation, b_address, b_tel, seq): Observable<any> {
    let URL = cmsApi + '/add_job_register_family_brother_sister';
    let body = {
      personid: personid,
      b_title: b_title,
      b_fname: b_fname,
      b_lname: b_lname,
      b_age: b_age,
      b_occupation: b_occupation,
      b_address: b_address,
      b_tel: b_tel,
      seq: seq
    }
    if (this.isTesting) {
      console.log('setbrother', body)
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
        }, 100);
      });
    } else {
      return this.http.post(URL, body);
    }
  }

  // add_job_register_s_family
  setSpouse(personid, s_title, s_fname, s_lname, s_age, s_occupation, s_address, s_tel): Observable<any> {
    let URL = cmsApi + '/add_job_register_s_family';
    let body = {
      personid: personid,
      s_title: s_title,
      s_fname: s_fname,
      s_lname: s_lname,
      s_age: s_age,
      s_occupation: s_occupation,
      s_address: s_address,
      s_tel: s_tel,
    }
    if (this.isTesting) {
      console.log('setSpouse', body)
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
        }, 100);
      });
    } else {
      return this.http.post(URL, body);
    }
  }

  // add_job_register_experience_lastJob
  setExperienceLastJobs(param:IJobExpJob): Observable<any> {
    let URL = cmsApi + '/add_job_register_experience_lastJobs';
    if (this.isTesting) {
      console.log('setExperienceLastJob body: ', param);
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
        }, 100);
      });
    } else {
      return this.http.post(URL, param);
    }
  }
  setExperienceLastJob(body): Observable<any> {
    let URL = cmsApi + '/add_job_register_experience_lastJob';
    if (this.isTesting) {
      console.log('setExperienceLastJob body: ', body);
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
        }, 100);
      });
    } else {
      return this.http.post(URL, body);
    }
  }

  // add_job_register_experience_reference
  setExperienceReference(personid, ref_title, ref_fname, ref_lname, ref_position, ref_tel, ref_relation, seq): Observable<any> {
    let URL = cmsApi + '/add_job_register_experience_reference';
    let body = {
      personid: personid,
      ref_title: ref_title,
      ref_fname: ref_fname,
      ref_lname: ref_lname,
      ref_position: ref_position,
      ref_tel: ref_tel,
      ref_relation: ref_relation,
      seq: seq
    }
    if (this.isTesting) {
      console.log('setExperienceReference body: ', body);
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
        }, 100);
      });
    } else {
      return this.http.post(URL, body);
    }

  }


  // add_job_register_experience
  setCheckExperiences(param:IJobExpInfo): Observable<any> {
    let URL = cmsApi + '/add_job_register_experiences';
    if (this.isTesting) {
      console.log('setCheckExperience body: ', param);
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
        }, 100);
      });
    } else {
      return this.http.post(URL, param);
    }
  }
  setCheckExperience(personid, flag_illegal, illegal_remark, flag_NotPerfect, NotPerfect_remark, flag_sack, sack_remark, flag_WorkWithAsset, WorkWithAsset_reamrk, flag_confirm, flag_pdpa): Observable<any> {
    let URL = cmsApi + '/add_job_register_experience';
    let body = {
      personid: personid,
      flag_illegal: flag_illegal,
      illegal_remark: illegal_remark,
      flag_NotPerfect: flag_NotPerfect,
      NotPerfect_remark: NotPerfect_remark,
      flag_sack: flag_sack,
      sack_remark: sack_remark,
      flag_WorkWithAsset: flag_WorkWithAsset,
      WorkWithAsset_reamrk: WorkWithAsset_reamrk,
      flag_confirm: flag_confirm,
      flag_pdpa: flag_pdpa,
    }
    if (this.isTesting) {
      console.log('setCheckExperience body: ', body);
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
        }, 100);
      });
    } else {
      return this.http.post(URL, body);
    }
  }
}
